import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
  'vendor-management.field-1-name': {
    id: 'vendor-management.field-1-name',
    defaultMessage: 'Vendor',
    description:
      'The field name (and the default value/watermark) in field #1 for this database template. In this case: Vendor',
  },
  'vendor-management.field-2-name': {
    id: 'vendor-management.field-2-name',
    defaultMessage: 'Email',
    description:
      'The field name (and the default value/watermark) in field #2 for this database template. In this case: Email',
  },
  'vendor-management.field-3-name': {
    id: 'vendor-management.field-3-name',
    defaultMessage: 'Industry',
    description:
      'The field name (and the default value/watermark) in field #3 for this database template. In this case: Industry',
  },
  'vendor-management.field-3-select-option-1': {
    id: 'vendor-management.field-3-select-option-1',
    defaultMessage: 'eCommerce',
    description:
      'The option value for option #1 in field #3 for this database template. In this case: eCommerce',
  },
  'vendor-management.field-3-select-option-2': {
    id: 'vendor-management.field-3-select-option-2',
    defaultMessage: 'Financial Services',
    description:
      'The option value for option #2 in field #3 for this database template. In this case: Financial Services',
  },
  'vendor-management.field-3-select-option-3': {
    id: 'vendor-management.field-3-select-option-3',
    defaultMessage: 'Retail',
    description:
      'The option value for option #3 in field #3 for this database template. In this case: Retail',
  },
  'vendor-management.field-3-select-option-4': {
    id: 'vendor-management.field-3-select-option-4',
    defaultMessage: 'Nonprofit',
    description:
      'The option value for option #4 in field #3 for this database template. In this case: Nonprofit',
  },
  'vendor-management.field-3-select-option-5': {
    id: 'vendor-management.field-3-select-option-5',
    defaultMessage: 'Environment',
    description:
      'The option value for option #5 in field #3 for this database template. In this case: Environment',
  },
  'vendor-management.field-4-name': {
    id: 'vendor-management.field-4-name',
    defaultMessage: 'Resources',
    description:
      'The field name (and the default value/watermark) in field #4 for this database template. In this case: Resources',
  },
  'vendor-management.field-5-name': {
    id: 'vendor-management.field-5-name',
    defaultMessage: 'Media',
    description:
      'The field name (and the default value/watermark) in field #5 for this database template. In this case: Media',
  },
  'vendor-management.view-1-name': {
    id: 'vendor-management.view-1-name',
    defaultMessage: 'All vendors',
    description:
      'The view name for view #1 in this template. Displayed on the top left of the screen (below the database name). In this case: All vendors',
  },
  'vendor-management.entry-1-cell-1': {
    id: 'vendor-management.entry-1-cell-1',
    defaultMessage: 'Idea Thread',
    description:
      'The text value of cell #1 in row (entry) #1 in this database template. In this case:  Idea Thread',
  },
  'vendor-management.entry-1-cell-2': {
    id: 'vendor-management.entry-1-cell-2',
    defaultMessage: 'ecommerce@ideathread.com',
    description:
      'The text value of cell #2 in row (entry) #1 in this database template. In this case:  ecommerce@ideathread.com',
  },
  'vendor-management.entry-2-cell-1': {
    id: 'vendor-management.entry-2-cell-1',
    defaultMessage: 'Prosperify Investments',
    description:
      'The text value of cell #1 in row (entry) #2 in this database template. In this case:  Prosperify Investments',
  },
  'vendor-management.entry-2-cell-2': {
    id: 'vendor-management.entry-2-cell-2',
    defaultMessage: 'sales@prosperifyinvestments.com',
    description:
      'The text value of cell #2 in row (entry) #2 in this database template. In this case:  sales@prosperifyinvestments.com',
  },
  'vendor-management.entry-3-cell-1': {
    id: 'vendor-management.entry-3-cell-1',
    defaultMessage: 'Stackies',
    description:
      'The text value of cell #1 in row (entry) #3 in this database template. In this case:  Stackies',
  },
  'vendor-management.entry-3-cell-2': {
    id: 'vendor-management.entry-3-cell-2',
    defaultMessage: 'product@stackies.com',
    description:
      'The text value of cell #2 in row (entry) #3 in this database template. In this case:  product@stackies.com',
  },
  'vendor-management.entry-4-cell-1': {
    id: 'vendor-management.entry-4-cell-1',
    defaultMessage: 'Thrive 4 Tomorrow ',
    description:
      'The text value of cell #1 in row (entry) #4 in this database template. In this case:  Thrive 4 Tomorrow ',
  },
  'vendor-management.entry-4-cell-2': {
    id: 'vendor-management.entry-4-cell-2',
    defaultMessage: 'nonprofit@thrive4tomorrow.com',
    description:
      'The text value of cell #2 in row (entry) #4 in this database template. In this case:  nonprofit@thrive4tomorrow.com',
  },
  'vendor-management.entry-5-cell-1': {
    id: 'vendor-management.entry-5-cell-1',
    defaultMessage: 'NSCIA',
    description:
      'The text value of cell #1 in row (entry) #5 in this database template. In this case:  NSCIA',
  },
  'vendor-management.entry-5-cell-2': {
    id: 'vendor-management.entry-5-cell-2',
    defaultMessage: 'environment@nscia.com',
    description:
      'The text value of cell #2 in row (entry) #5 in this database template. In this case:  environment@nscia.com',
  },
});
